import "@/index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "@/App";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import { logger } from "@/lib/logger";
import { reportWebVitals } from "@/lib/web-vitals";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element was not found.");
}

if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    logger.error("window.error", {
      error: event.error ?? event.message,
      filename: event.filename,
    });
  });
  window.addEventListener("unhandledrejection", (event) => {
    logger.error("window.unhandledrejection", { reason: event.reason });
  });
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);

reportWebVitals();
